package com.example.positionahead.model

enum class AnalyticsWidgetType(val label: String) {
    PORTFOLIO_TREND("Portfolio trend"),
    HOLDINGS("Holdings charts"),
    ;

    companion object {
        val defaultOrder: List<AnalyticsWidgetType> = entries.toList()

        fun fromId(id: String): AnalyticsWidgetType? =
            entries.find { it.name == id }
                ?: legacyMapping[id]

        private val legacyMapping = mapOf(
            "PRICE" to PORTFOLIO_TREND,
            "SHARES" to HOLDINGS,
            "ESTIMATED_INCOME" to HOLDINGS,
            "VALUE" to HOLDINGS,
            "UNREALIZED_GL" to HOLDINGS,
            "PERFORMANCE" to PORTFOLIO_TREND,
        )
    }
}
